import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Ensure you have react-router-dom installed
import { Line } from 'react-chartjs-2';
import { 
  Chart as ChartJS, 
  CategoryScale, 
  LinearScale, 
  PointElement, 
  LineElement, 
  Title, 
  Tooltip, 
  Legend 
} from 'chart.js';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const AdminDashboard = () => {
  const navigate = useNavigate(); // Hook to programmatically navigate
  const [salesPeriod, setSalesPeriod] = useState('weekly');

  // Check session on component mount
  useEffect(() => {
    const sessionToken = localStorage.getItem('adminToken');
    console.log(sessionToken)
    if (!sessionToken) {
      navigate('/'); // Redirect to homepage
    }
  }, [navigate]);

  // Sales data configuration
  const salesData = {
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    datasets: [
      {
        label: 'Sales',
        data: [65, 59, 80, 81, 56, 55, 40],
        borderColor: 'rgb(75, 192, 192)',
        tension: 0.1
      }
    ]
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Sales Overview'
      }
    }
  };

  return (
    <div className="p-6 bg-gray-100">
      <div className="grid grid-cols-4 gap-6 mb-6">
        {/* Order Statistics Cards */}
        {[
          { 
            title: 'Total Orders', 
            value: '254', 
            change: '+12.5%', 
            color: 'bg-blue-500' 
          },
          { 
            title: 'Active Orders', 
            value: '65', 
            change: '+8.2%', 
            color: 'bg-green-500' 
          },
          { 
            title: 'Completed Orders', 
            value: '189', 
            change: '+15.7%', 
            color: 'bg-purple-500' 
          },
          { 
            title: 'Return Orders', 
            value: '12', 
            change: '-2.3%', 
            color: 'bg-red-500' 
          }
        ].map((card, index) => (
          <div 
            key={index} 
            className={`${card.color} text-white p-6 rounded-lg shadow-md`}
          >
            <div className="flex justify-between items-center">
              <div>
                <h3 className="text-sm font-medium">{card.title}</h3>
                <p className="text-2xl font-bold">{card.value}</p>
              </div>
              <span className={`
                ${card.change.startsWith('+') 
                  ? 'bg-green-600' 
                  : 'bg-red-600'
                } px-2 py-1 rounded text-xs`}
              >
                {card.change}
              </span>
            </div>
          </div>
        ))}
      </div>

      {/* Sales Graph Section */}
      <div className="bg-white rounded-lg shadow-md p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Sales Overview</h2>
          <div className="flex space-x-2">
            {['Weekly', 'Monthly', 'Yearly'].map((period) => (
              <button
                key={period}
                onClick={() => setSalesPeriod(period.toLowerCase())}
                className={`
                  px-4 py-2 rounded-md text-sm 
                  ${salesPeriod === period.toLowerCase() 
                    ? 'bg-blue-500 text-white' 
                    : 'bg-gray-200 text-gray-700'
                  }
                `}
              >
                {period}
              </button>
            ))}
          </div>
        </div>
        
        <Line data={salesData} options={chartOptions} />
      </div>

      {/* Recent Orders Table */}
      <div className="bg-white rounded-lg shadow-md p-6 mt-6">
        <h2 className="text-xl font-semibold mb-4">Recent Orders</h2>
        <table className="w-full">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-3 text-left">Product Name</th>
              <th className="p-3 text-left">Order ID</th>
              <th className="p-3 text-left">Date</th>
              <th className="p-3 text-left">Customer</th>
              <th className="p-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {[
              {
                product: 'Laptop',
                orderId: '#12345',
                date: '2023-06-15',
                customer: 'John Doe',
                status: 'Completed'
              },
              {
                product: 'Smartphone',
                orderId: '#12346',
                date: '2023-06-14',
                customer: 'Jane Smith',
                status: 'Pending'
              }
            ].map((order, index) => (
              <tr key={index} className="border-b hover:bg-gray-50">
                <td className="p-3">{order.product}</td>
                <td className="p-3">{order.orderId}</td>
                <td className="p-3">{order.date}</td>
                <td className="p-3">{order.customer}</td>
                <td className="p-3">
                  <span className={`
                    px-2 py-1 rounded-full text-xs 
                    ${order.status === 'Completed' 
                      ? 'bg-green-200 text-green-800' 
                      : 'bg-yellow-200 text-yellow-800'
                    }
                  `}>
                    {order.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminDashboard;
